export const setActiveMarketplace = marketplace => ({
  type: 'SET_ACTIVE_MARKETPLACE',
  marketplace,
});

export const setMarketplaceComps = comps => ({
  type: 'SET_MARKETPLACE_COMPS',
  comps,
});

export const setShowSHListPrice = status => ({
  type: 'SET_SHOW_SH_LIST_PRICE',
  status,
});

export const setShowTMRListPrice = status => ({
  type: 'SET_SHOW_TMR_LIST_PRICE',
  status,
});

export const setShowVSListPrice = status => ({
  type: 'SET_SHOW_VS_LIST_PRICE',
  status,
});

export const setShowMPListPrice = status => ({
  type: 'SET_SHOW_MP_LIST_PRICE',
  status,
});
